export const Constants = {
  ACTIVE_OPACITY: 0.8,
};

export const FILTER_CONSTANTS = {
  DEFAULT_DURATION: [100, 86399999],
  DEFAULT_PRICE_RANK: [1, 20],
};

export const USE_QUERY_CONSTANTS = {
  cacheMs: 3000000,
  staleMs: 3000000,
  retry: 1,
  refetchOnWindowFocus: false,
};

export const SEAT_STATUS = {
  AVAILABLE: 'available',
  BOOKED: 'booked',
  BUSY: 'pending',
  SELECTED: 'selected',
};

export enum SEAT_TYPE {
  DRIVER = 'driver',
  PASSENGER = 'passenger',
}

// export const SEAT_TYPE = {
//   DRIVER: 'driver',
//   PASSENGER: 'passenger',
// };
